<template>
  <div id="tab-bar">
    <!--  <el-container>-->
    <el-container>
      <el-header>
        <div
          v-if="brand == 'IR'"
          class="logoName fl"
          :style="{ width: isCollapse ? '57px' : '226px' }"
        >
          <img v-if="!isCollapse" src="~assets/img/logo.png" />
          <img v-if="isCollapse" src="~assets/img/HELIX_Slogo.png" />
        </div>
        <div
          v-if="brand == 'GD'"
          class="logoName fl"
          :style="{ width: isCollapse ? '57px' : '226px' }"
          style="padding-left: 10px; padding-right: 30px"
        >
          <img src="~assets/img/logo2.png" />
        </div>
        <div class="usediv fr">
          <el-dropdown @command="password">
            <span class="el-dropdown-link userName">
              {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="userDivDrop">
              <el-dropdown-item>
                <div class="SubTitle">{{ $t("desc.languageSwitch") }}</div>
                <el-button
                  size="small"
                  type="text"
                  :style="
                    activeLang == 'zh' ? 'color: #E62E19; ' : 'color:#828393'
                  "
                  @click="changeLanguage('zh')"
                  class="userDownBtn"
                  >中文
                </el-button>
                <span class="VerticalLine">|</span>
                <el-button
                  size="small"
                  type="text"
                  :style="
                    activeLang == 'en' ? 'color: #E62E19; ' : 'color:#828393'
                  "
                  @click="changeLanguage('en')"
                  class="userDownBtn"
                  >EN
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item command="edit" divided>{{
                $t("desc.changePaw")
              }}</el-dropdown-item>
              <el-dropdown-item command="layout">{{
                $t("desc.LogOut")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="topdiv fr">
          <el-button
            class="topBtn toggle-button"
            id="menuBtn"
            @click="togleCollapse"
            ><img src="~assets/img/icon_more.png"
          /></el-button>
          <!-- 如果有报警，增加数量 :value="3" @click="openWarning"-->

          <el-button
            class="topBtn"
            id="plainBtn"
            plain
            @click="openWarning"
            style="margin-left: 20px"
          >
            <img src="~assets/img/icon_alarm.png" />
          </el-button>

          <!-- <el-badge :value="alarmNum" class="item">
            <el-button class="topBtn" id="plainBtn" plain @click="openWarning"
              ><i class="fa fa-bell-o"></i
            ></el-button>
          </el-badge> -->

          <!-- 如果有推送，增加数量 :value="3" -->
          <el-badge :value="messageNum" class="item">
            <el-button class="topBtn" id="plainBtn" plain @click="openNotice"
              ><img src="~assets/img/icon_message.png"
            /></el-button>
          </el-badge>

          <!-- <span class="telDiv" v-if="brand == 'IR'"
            >{{ $t("desc.customerHotline") }}
            <i class="el-icon-mobile-phone"></i>4008-202-128
            <i class="el-icon-phone"></i>8008-202-128
          </span>

          <span class="telDiv" v-if="brand == 'GD'"
            >{{ $t("desc.customerHotline") }}
            <i class="el-icon-mobile-phone"></i>4008-209-290
          </span> -->
        </div>
      </el-header>
    </el-container>

    <el-container>
      <el-scrollbar
        class="leftSide"
        :style="{ width: isCollapse ? '97px' : '266px' }"
      >
        <el-aside>
          <el-menu
            router
            unique-opened
            :default-active="$route.path"
            @select="handleSelect"
            :collapse="isCollapse"
            :collapse-transition="false"
          >
            <el-menu-item index="/client/default">
              <div
                class="iconBorder"
                :style="{ width: isCollapse ? '29px' : '200px' }"
              >
                <img src="~assets/img/menu/icon1_on.png" />
              </div>
              <span slot="title">{{ $t("menu.Home_View") }}</span>
            </el-menu-item>
            <el-menu-item index="/client/monitor">
              <div
                class="iconBorder"
                :style="{ width: isCollapse ? '29px' : '200px' }"
              >
                <img src="~assets/img/menu/icon7_on.png" />
              </div>
              <span slot="title">{{
                $t("web.DeviceMonitorManagement_View")
              }}</span>
            </el-menu-item>
            <el-menu-item index="/client/opensoon1">
              <div
                class="iconBorder"
                :style="{ width: isCollapse ? '29px' : '200px' }"
              >
                <img src="~assets/img/menu/icon4_on.png" />
              </div>
              <span slot="title">{{ $t("menu.StatisticalForm") }}</span>
            </el-menu-item>
            <el-menu-item index="/client/AlarmList">
              <div
                class="iconBorder"
                :style="{ width: isCollapse ? '29px' : '200px' }"
              >
                <img src="~assets/img/menu/icon8_on.png" />
              </div>
              <span slot="title">{{ $t("menu.Alarm_View") }}</span>
            </el-menu-item>
            <!-- <el-menu-item index="/client/noticeList">
              <i class="fa fa-envelope-o"></i>
              <span slot="title">{{ $t("menu.StationInfo") }}</span>
            </el-menu-item> -->
            <!-- <el-menu-item index="/client/maintainList">
              <div
                class="iconBorder"
                :style="{ width: isCollapse ? '29px' : '200px' }"
              >
                <img src="~assets/img/menu/icon3_on.png" />
              </div>
              <span slot="title">{{ $t("menu.MaintenancePlan") }}</span
              >// 二期开发 
            </el-menu-item> -->
            <!-- <el-menu-item index="/client/Account">
                          <i class="fa fa-drivers-license-o"></i>
                          <span slot="title">账号管理</span>
                        </el-menu-item> -->
          </el-menu>
        </el-aside>
      </el-scrollbar>
      <slot></slot>
      <!--    </el-container>-->
    </el-container>
  </div>
</template>
<style lang="less"></style>
<script>
import {
  GetAlarmCount,
  checkLoginClient,
  GetPushMessageCounts,
  logout,
} from "../../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  setItemToLocalstorage,
  delItemFormLocalstorage,
  getItemFormLocalstorage,
} from "../../../../utils/package-localstorage";
import { delCookie } from "../../../../utils/package-cookies";
import defaultSettings from "@/config/defaultSettings";
export default {
  name: "MainTabBarClient",

  data() {
    return {
      userName: "",
      menuList: [],
      //activeLang: "",
      currentPage: "/customer/customerCenterMgt",
      alarmNum: "",
      messageNum: "",
      brand: "",
    };
  },
  // watch:{
  //     userName:{
  //       handler(val,old){
  //           this.userName=val
  //       },
  //       deep:true
  //   }
  // },
  async mounted() {
    this.brand = Globals.VUE_APP_Brand;
    checkLoginClient();
    this.getUserName();
    //this.getAlarmCounts();
    this.getPushMessageCounts();
  },
  components: {},
  methods: {
    ...mapMutations([
      "setLanguage",
      "setMenuListState",
      "setAuthOperationState",
    ]),
    handleSelect() {},
    getUserName() {
      this.userName = getItemFormLocalstorage("userName");
    },
    changeLanguage(lang) {
      window.localStorage.setItem("user_lang", lang);
      this.setLanguage(lang);
      window.location.reload();
    },
    password(value) {
      if (value == "edit") {
        this.$router.push({ path: "/client/editPassword" });
      } else if (value == "layout") {
        logout()
          .then((r) => {
            delCookie("userSessionID");
            delItemFormLocalstorage("userInfo");
            delItemFormLocalstorage("customer");
            delItemFormLocalstorage("auth");
            delItemFormLocalstorage("TokenExpire");
            delItemFormLocalstorage("refreshtime");
            delItemFormLocalstorage("expires_in");
            delItemFormLocalstorage("menuData");
            delItemFormLocalstorage("authOperations");
            delItemFormLocalstorage("AlarmCount");
            delItemFormLocalstorage("isneedchange");
            sessionStorage.clear();
            delCookie("auth");
            delCookie("userName");
            delCookie("Abp.AuthToken");
            delCookie("vid");
            this.$router.push({ path: "/clientlogin" });
          })
          .catch((err) => {
            this.$router.push({ path: "/clientlogin" });
          });
      }
      // else if (value == "changeLanguage") {
      //   this.changeLanguage();
      // }
    },
    gotoHome() {
      window.location.href = "/client/default";
    },
    openNotice() {
      this.$router.push({ path: "/client/noticeList" });
    },
    openWarning() {
      this.$router.push({
        name: "/client/AlarmList",
        params: {
          readStatus: "0",
        },
      });
    },
    // async getAlarmCounts() {
    //   var that = this;
    //   await GetAlarmCount().then((res) => {
    //     if (res.success === true) {
    //       if (res.result == "0") {
    //         that.alarmNum = "";
    //       } else if (parseInt(res.result) > 99) {
    //         that.alarmNum = "···";
    //       } else {
    //         that.alarmNum = res.result;
    //       }
    //       setItemToLocalstorage("AlarmCount", that.alarmNum);
    //     }
    //   });
    // },
    async getPushMessageCounts() {
      var that = this;
      var data = {};
      data.Keyword = "";
      data.SkipCount = 0;
      data.MaxResultCount = 1;

      GetPushMessageCounts(data).then((res) => {
        if (res.success) {
          let counts = res.result.totalCount;
          if (counts == "0") {
            that.messageNum = "";
          } else if (parseInt(counts) > 99) {
            that.messageNum = "···";
          } else {
            that.messageNum = counts;
          }
          setItemToLocalstorage("cMessageNum", that.messageNum);
        }
      });
    },
    togleCollapse() {
      this.$store.commit("changeCollapse");
    },
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
      menuListStore: "menuListState",
      authOperationStore: "authOperationState",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
      //activeLang: (state) => state.language,
    }),
  },
};
</script>

<style scoped>
#el-header {
  padding: 0;
  height: 60px;
  background-color: #e1e1e4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.topdiv {
  height: 60px;
  border-right: 1px solid #c1bec6;
}
</style>
